import React, { useState } from "react";
import requireAuth from "../context/requireAuth";
import axios from "axios";
import { Navigate } from "react-router-dom";

function NewAccount() {

    const [formData, setFormData] = useState({})

    const org_id = localStorage.getItem("organization");

    const handleSubmit = (e) => {
        e.preventDefault()
        axios.post(`/${org_id}/createuser`, formData, {withCredentials: true})
        .then(res => {
            console.log(res.data);
            alert("Account created successfully!");
        }
        )
        .catch(err => {
            console.log(err)
            alert("Error creating account. Please check if fields are filled in correctly and try again.");
        });
    }

    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    }

    return(
        <div className="bodyContent">
            <h1 className="title">New Account</h1>
                <div className="editFormDiv">
                <form className="editForm" onSubmit={handleSubmit}>
                    <label htmlFor="email">Email</label>
                    <input type="text" className="editInput newMaintenanceInput" name="email" id="email" onChange={handleChange}/>
                    <br />
                    <label htmlFor="first_name">First Name</label>
                    <input type="text" className="editInput newMaintenanceInput" name="first_name" id="first_name" onChange={handleChange}/>
                    <br />
                    <label htmlFor="first_name">Last Name</label>
                    <input type="text" className="editInput newMaintenanceInput" name="last_name" id="first_name" onChange={handleChange}/>
                    <br />
                    {/* <label htmlFor="role">Work Role</label>
                    <select name="role" id="role" className="editInput newMaintenanceInput">
                        <option value="leader">Project Leader</option>
                        <option value="member">Project Member</option>
                    </select> */}

                    <input type="submit" value="Create Account" className="maintenanceFormSubmit"/>
                </form>
                </div>
            </div>
    )
}

export default requireAuth(NewAccount);